import { FC, ReactNode } from "react";
import { Box, Typography } from "@mui/material";

// A label over its value, styled like the claim's key info (ClaimKeyInfoSection)
const InfoItem: FC<{
  label: string;
  valueColor?: string;
  /** Span every column of the surrounding grid */
  fullWidth?: boolean;
  children: ReactNode;
}> = ({ label, valueColor, fullWidth, children }) => (
  <Box sx={{ minWidth: 0, gridColumn: fullWidth ? "1 / -1" : undefined }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontSize: "0.65rem", textTransform: "uppercase" }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      fontWeight={500}
      sx={{ fontSize: "0.8rem", color: valueColor, wordBreak: "break-word" }}
    >
      {children}
    </Typography>
  </Box>
);

/** Section label over a block (e.g. a document card), matching InfoItem's label. */
export const InfoSectionLabel: FC<{ children: ReactNode }> = ({ children }) => (
  <Typography
    variant="caption"
    color="text.secondary"
    component="div"
    sx={{ fontSize: "0.65rem", textTransform: "uppercase", mb: 1 }}
  >
    {children}
  </Typography>
);

export default InfoItem;
